module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-2-18e53b8b09dfae67c72480fc83e93898.jpg";